import React, { HtmlHTMLAttributes, useState } from "react";
import Typography from "../../../Foundation/Typography/Typography";
import { IThemeMode } from "../../../Themes/defaultTheme";
import ArrowNavigation from "../../ArrowNavigation/ArrowNavigation";
import {
  _EmailRegisterInput,
  _EmailRegisterRoot,
} from "./EmailRegister.styled";

export interface IEmailRegisterProps
  extends Omit<HtmlHTMLAttributes<HTMLInputElement>, "onSubmit" | "title"> {
  placeholder?: string;
  mode?: IThemeMode;
  loading?: boolean;
  name?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onSubmit?: () => void;
}

const EmailRegister = (props: IEmailRegisterProps) => {
  const {
    onSubmit,
    mode = "dark",
    placeholder = "E-mail",
    loading,
    name = "email",
    value,
    onChange,
    ...inputProps
  } = props;

  const [email, setEmail] = useState<string>(value || "");
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setEmail(e.target.value);
    onChange?.(e);
  };
  const handleOnSubmit = () => {
    onSubmit && onSubmit();
  };

  return (
    <_EmailRegisterRoot>
      <Typography style={{ flex: 1 }} variant="button" color="greyText">
        <_EmailRegisterInput
          type="email"
          placeholder={placeholder}
          value={email}
          name={name}
          onChange={handleChange}
          {...inputProps}
        />
      </Typography>
      <ArrowNavigation
        as="button"
        type="submit"
        direction="right"
        mode={mode}
        disabled={loading}
        onClick={handleOnSubmit}
      />
    </_EmailRegisterRoot>
  );
};

export default EmailRegister;
